import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "番剧分类", href: "#category" },
  { label: "人气排行", href: "#rank" },
  { label: "新番速递", href: "#new" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
            <i className="ri-footprint-line"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            小狗看番
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-100/70"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索番剧"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-base"></i>
          </button>
          <a
            href="#new"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            开始看番
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg md:hidden text-background-50 bg-background-50/15 cursor-pointer"
        >
          <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50/95 backdrop-blur border-t border-background-200 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100/70 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#new"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            开始看番
          </a>
        </div>
      )}
    </header>
  );
}